import { render, staticRenderFns } from "./ProfileIndex.vue?vue&type=template&id=150c0478"
import script from "./ProfileIndex.vue?vue&type=script&lang=js"
export * from "./ProfileIndex.vue?vue&type=script&lang=js"
import style0 from "./ProfileIndex.vue?vue&type=style&index=0&id=150c0478&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports